import {addPreloadParam} from "../utils/SearchUrlUtil";

/**
 * window.history.pushState is a native API which adds on browser history a new entry which allows to manually override/enrich the navigation history.
 * This technique is used in SPA to mimic page transition and specify how browser should behave on back/forward operations.
 *
 * After every pushState/replaceState the page url/title will be updated accordingly without reloading the page.
 *
 * @param url which will be used on back/forward/go operation
 * @param title of the page
 * @param additionalStateData additional data that will be applied on history entry
 */

export const addNewPageInHistory = (url, additionalStateData, title) =>{
  const history = window.history;
  if (history && history.pushState && url && url.trim().length > 0) {
    history.pushState(additionalStateData, title || window.document.title, url);
  }
}

export const replacePageInHistory = (url, additionalStateData, title, needPreload) => {
  const history = window.history;
  if (history && history.replaceState && url && url.trim().length > 0) {
    if (needPreload) {
      url = addPreloadParam(url);
    }
    history.replaceState(additionalStateData, title || window.document.title, url);
    if (additionalStateData && additionalStateData.focusElement) {
      history.scrollRestoration = 'manual';
    }
  }
}

export const hasFocusElement = ()=>{
  return !!getFocusElement();
}

export const getFocusElement = ()=>{
  const history = window.history;
  return history && history.state && history.state.focusElement;
}

